'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var nthHookSettings = require('@narvar/nth-hook-settings');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

function camelToSpaceCase(str) {
  return str.replace(/[A-Z]/g, letter => `-${letter.toLowerCase()}`);
}
function styleObjectToString(style) {
  return Object.entries(style).map(([key, value]) => {
    const normalizedKey = camelToSpaceCase(key);
    if (typeof value === 'object') {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
      return `${normalizedKey}{${styleObjectToString(value)};}`;
    }
    if (normalizedKey === 'font-family') {
      // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
      return `${normalizedKey}:'${value}'`;
    }

    // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
    return `${normalizedKey}:${value}`;
  }).join(';');
}
function createStyleElement(styleString) {
  const styleElement = document.createElement('style');
  styleElement.innerHTML = styleString;
  document.head.appendChild(styleElement);
}
const GlobalStyleTag = () => {
  const {
    globalScopeCSS
  } = nthHookSettings.useSettings();
  React.useEffect(() => {
    if (!globalScopeCSS) return;
    const globalStyles = globalScopeCSS.map(styleObject => {
      return styleObjectToString(styleObject);
    });
    createStyleElement(globalStyles.join(''));
  }, [globalScopeCSS]);
  return /*#__PURE__*/React__default["default"].createElement(React.Fragment, null);
};
var index = nthHookSettings.withSettingsProvider(GlobalStyleTag, {
  settingsRequested: 'globalScopeCSS'
});

exports["default"] = index;
